export default __webpack_public_path__ + "static/media/insects.a092c4c2.webp";